/**
 * @fileoverview Renderer for the 'ask' tool.
 * Displays user-facing content with optional attachments.
 */

'use client';

import { Markdown } from '@/components/ui';
import { SimpleAttachmentList, parseAttachments } from '../components';

interface AskRendererProps {
  /** Input containing text and attachments */
  input: {
    text?: string;
    content?: string;
    attachments?: string | string[];
  };
  /** Sandbox ID for file operations */
  sandboxId?: string;
}

/**
 * Renders the ask tool as content instead of a tool call badge.
 */
export function AskRenderer({ input, sandboxId }: AskRendererProps) {
  const askText = input?.text || input?.content || '';
  const attachmentArray = parseAttachments(input?.attachments);

  if (!askText && attachmentArray.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {askText && (
        <div className="max-w-none break-words">
          <Markdown className="prose-sm" density="chat">
            {askText}
          </Markdown>
        </div>
      )}
      {attachmentArray.length > 0 && (
        <SimpleAttachmentList attachments={attachmentArray} sandboxId={sandboxId} />
      )}
    </div>
  );
}
